import MovexGeo from "@movexgeo/react-native-movex";

/**
 * Mirrors the `{ coords: { latitude, longitude, accuracy } }` shape
 * that react-native-geolocation-service returned, so existing callsites
 * switch with minimal churn.
 *
 * Backed by MovexGeo.captureCurrentPosition — does NOT require the SDK
 * to be initialised, safe to call pre-login.
 *
 * Caller must hold ACCESS_FINE_LOCATION; rejects with a MovexGeoError
 * { code: 'permission_denied' } otherwise.
 */
const getCurrentLocation = async ({
  highAccuracy = true,
  timeoutMs = 10000,
} = {}) => {
  const fix = await MovexGeo.captureCurrentPosition({
    enable_high_accuracy: highAccuracy,
    timeout_ms: timeoutMs,
  });
  return {
    coords: {
      latitude: fix.lat,
      longitude: fix.lng,
      accuracy: fix.accuracy_m,
    },
  };
};

export default getCurrentLocation;
